// Core exports
export { Sessionable } from './core/sessionable';

// Types
export type { SessionableOptions, SessionMetrics, SessionPayload } from './types';

// Version info
export const VERSION = '0.1.0';